import { Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'daysPipe',
    standalone: true,
})
export class DaysPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(days: string): string {
        let value: string = '';

        days.split(',').forEach((a) => (value += this.translateService.instant('EnumDaysOfWeek.' + a.trim()) + ', '));

        return value.substring(0, value.length - 2);
    }
}
